import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult, selectTotalScore } from 'store/player/playerSelectors';
// i18next
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

type Props = {
  scoreVisible?: boolean;
}

const AppBar:FC<Props> = ({
  // Props
  scoreVisible = false
}) => {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);
  const totalScore:number = useAppSelector(selectTotalScore);

  const isRegisterPage = pathname.endsWith('/register');
  const showSponsorImageOnRegisterPage = quiz.showSponsorImageOnRegisterPage && quiz.sponsorImage;

  const alt = result && result.quizGroup ? result.quizGroup.name : quiz.quizName; 
  const src = result && result.quizGroup
    ? result.quizGroup.logoImage
    : isRegisterPage && showSponsorImageOnRegisterPage
      ? quiz.sponsorImage
      : quiz.logoImage;

  return (
    <div
      className="
        shrink-0 flex items-center
        bg-primary shadow
        rounded-br-lg rounded-bl-lg
        p-2
        z-40
        overflow-hidden
      "
    >
      {scoreVisible ? <div style={{ width: 72 }}></div> : null}
      <div className="flex-grow flex justify-center">
        <img className="h-14" src={src} alt={alt} style={{
          filter: 'drop-shadow(0 0 10px rgba(0, 0, 0, 0.7)) drop-shadow(0 0 15px rgba(255, 255, 255, 0.8))'
        }} />
      </div>
      {scoreVisible ? (
        <div className="flex flex-col bg-gray-200 rounded p-1" style={{ width: 72 }}>
          <span className="text-xss leading-4 text-center">{t('components.quizAppBar.totalScore')}</span>
          <span className="text-sm leading-4 text-center font-bold">{totalScore}</span>
        </div>
      ) : null}
    </div>
  )
}

export default AppBar;
